import React, { useState, useEffect } from "react";
import map_icon from "../img/icon_mapmode2_white.png"

const CoordsCellEditor = (props) => {
    const { value, onValueChange } = props;
    const [latitude, setLatitude] = useState(value?.latitude || "");
    const [longitude, setLongitude] = useState(value?.longitude || "");
    const [selectingCoords, setSelectingCoords] = useState(false);

    useEffect(() => {
        onValueChange({ latitude, longitude });
    }, [latitude, longitude, onValueChange]);


    const openMapForCoords = () => {
      setSelectingCoords(true);
      props.context.openMapForCoords({lat: latitude, lng: longitude});
    }

    const closeMapForCoords = () => {
      setSelectingCoords(false);
      props.context.closeMapForCoords();
    }

    useEffect(() => {
      //for some reason this useEffect is triggered as soon as the editor is instantiated
      //if a "select coords from map" has been used before
      //so we bypass the override if there's njo map open
      if(document.querySelector("#the_map_container") && document.querySelector("#the_map_container").style.display === 'none'){
        return;
      }

      if(props.context?.selectedCoords){
          setLatitude(props.context.selectedCoords.lat);
          setLongitude(props.context.selectedCoords.lng);
      }
    }, [props.context?.selectedCoords]);


    const onBlur = () => {
        //props.stopEditing();
    };

    return (
        <div style={{display:"flex", flexDirection:"row"}}>
          <div>
            { !selectingCoords && (
              <button className="map-button-coords" onClick={openMapForCoords}>
                <img className="map-button-coords-image" src={map_icon} alt="" />
              </button>
            )}
            { selectingCoords && (
              <button className="map-button-confirm" onClick={closeMapForCoords}>
                OK
              </button>
            )}
          </div>
          <div>
            <div class="double-editor-div-1">
                <input

                    className="double-editor-input"
                    type="text"
                    value={latitude}
                    onChange={(e) => setLatitude(e.target.value)}
                    onBlur={onBlur}
                    autoFocus
                />
            </div>
            <div class="double-editor-div-2">
                <input
                    id="double-editor-input-2"
                    className="double-editor-input"
                    type="text"
                    value={longitude}
                    onChange={(e) => setLongitude(e.target.value)}
                    onBlur={onBlur}
                />
            </div>
          </div>
        </div>
    );
};

export default CoordsCellEditor;
